import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Checkbox, FormControlLabel, Paper, Divider,Grid } from "@mui/material";
import { requestDeveloperAccess } from "../utils/api";
import { getCompanyName } from "../utils/utility";
import CustomSnackBar from "../Components/CustomSnackBar";
import { useGlobal } from "../Context/globalContext";

const textStyle = {
    "& .MuiInputBase-input": {
        fontSize: "12px",
    },
    "& .MuiInputBase-input.Mui-disabled": {
        fontSize: "12px",
    },
    "& .MuiInputLabel-root": {
        fontSize: "12px",
    },
    "& .MuiInputLabel-root.Mui-disabled": {
        fontSize: "12px",
    },
};

const DeveloperSignupForm = ({ onSuccess }) => {
    const { userData } = useGlobal();
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [organization, setOrganization] = useState("");
    const [description, setDescription] = useState("");
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [error, setError] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");

    const userName = userData?.profileData?.userName;
    const email = userData?.user?.email;
    const companyName = getCompanyName(email);

    useEffect(() => {
        if (companyName) setOrganization(companyName);
    }, [companyName]);

    const handleClose = () => {
        setOpenSnackBar(false);
        setError(false);
        setSnackbarMessage("");
    };

    const handleSubmit = async () => {
        if (!organization || !description || !checked) return;

        setLoading(true);
        try {
            const response = await requestDeveloperAccess(organization, "developer", description);

            if (response) {
                setError(false);
                setSnackbarMessage("Developer account created successfully!");
                setOpenSnackBar(true);

                setTimeout(() => {
                    onSuccess();
                }, 1500);
            }
        } catch (err) {
            console.error(err);
            setError(true);
            setSnackbarMessage("Something went wrong, please try again later.");
            setOpenSnackBar(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid container justifyContent="center">
            <Grid item xs={12} md={10} lg={10}>
                <Paper
                    elevation={4}
                    sx={{
                        p: 4,
                        borderRadius: "12px",
                        mt: 3,
                        bgcolor: "#fff",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    }}
                >
                    <Typography variant="h6" fontWeight="600" color="primary">
                        Developer Token Access Request
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        Submit this form to request access for publishing on HyperDart Developer Portal.
                    </Typography>

                    <Divider sx={{ mt: 2, mb: 3 }} />

                    <TextField label="Username" value={userName} disabled fullWidth margin="normal" sx={textStyle} />
                    <TextField label="Role" value="Developer" disabled fullWidth margin="normal" sx={textStyle} />
                    <TextField label="Token Expiration" value="Never" disabled fullWidth margin="normal" sx={textStyle} />

                    <TextField
                        label="Organization"
                        value={organization}
                        fullWidth
                        sx={textStyle}
                        required
                        margin="normal"
                        onChange={(e) => setOrganization(e.target.value)}
                    />

                    <TextField
                        label="Why do you need the token?"
                        value={description}
                        required
                        fullWidth
                        multiline
                        sx={textStyle}
                        rows={3}
                        margin="normal"
                        onChange={(e) => setDescription(e.target.value)}
                    />


                    <FormControlLabel
                        sx={{ mt: 1 }}
                        control={<Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)} />}
                        label="I agree and want to request developer token"
                    />

                    <Button
                        variant="contained"
                        fullWidth
                        disabled={!checked || !organization || !description || loading}
                        onClick={handleSubmit}
                        sx={{
                            mt: 2,
                            height: 48,
                            backgroundColor: "#f05f40",
                            "&:hover": { backgroundColor: "#d44a2f" }
                        }}
                    >
                        {loading ? "Submitting..." : "Submit Request"}
                    </Button>

                    <CustomSnackBar
                        open={openSnackBar}
                        handleClose={handleClose}
                        error={error}
                        message={snackbarMessage}
                    />
                </Paper>
            </Grid>
        </Grid>
    );
};

export default DeveloperSignupForm;
